
import request from '@/utils/request'
//登录
export function login(data) {
    return request({
      url: "api/login",
      method: "post",
      data,
      timeout:10000
    })
}
//退出
export function logout() {
  return request({
    url: 'api/logout',
    method: 'delete'
  })
}
export function getInfo() {
  return request({
    url: 'auth/info',
    method: 'get'
  })
}
//获取仓库
export function warehouse(params) {
    return request({
      url: "api/warehouse",
      method: "get",
      params,
    })
}
//根据仓库查订单数量
export function getWarehousesNumber(params) {
  return request({
    url: "api/warehouse/getWarehousesNumber",
    method: "get",
    params,
  })
}
//根据仓库获取线路
export function circuit(params){
    return request({
        url: "api/route",
        method: "get",
        params,
      })
}
//查询线路对应的运单数量api/route/gerRouteNumber
export function gerRouteNumber(params){
  return request({
      url: "api/route/gerRouteNumber",
      method: "get",
      params,
    })
}
//快递公司
export function express(params){
  return request({
    url: "api/expressCompany/getList",
    method: "get",
    params,
  })
}
//查询订单
export function orderList(params){
  return request({
    url: "api/order",
    method: "get",
    params,
  })
}
//查询订单详情
export function orderDetail(params){
  return request({
    url: "api/order/queryOrder",
    method: "get",
    params,
  })
}
//查询批次
export function batch(params){
  return request({
    url: "api/batch",
    method: "get",
    params,
  })
}
//商品种类
export function kind(params){
  return request({
    url: "api/category",
    method: "get",
    params,
  })
}
//箱子
export function boxList(params){
  return request({
    url: "api/orderbaggage",
    method: "get",
    params,
  })
}
//创建订单时搜索物品
export function goods(params){
  return request({
    url: "api/item",
    method: "get",
    params,
  })
}
//文件上传
export function fileUp(params){
  return request({
    url: "api/AWSUploadController/getuploadtoken",
    method: "get",
    params,
  })
}
//查询收货地址
export function address(params){
  return request({
    url: "api/sysShippingAddress",
    method: "get",
    params,
  })
}
//新增收货地址
export function addAddress(data){
  return request({
    url: "api/sysShippingAddress",
    method: "post",
    data,
  })
}
//修改收货地址
export function editAddress(data){
  return request({
    url: "api/sysShippingAddress",
    method: "put",
    data,
  })
}
//删除地址api/sysShippingAddress/{ids}
export function delAddress(data){
  return request({
    url: "api/sysShippingAddress/"+data,
    method: "DELETE",

  })
}
//预约上门
export function subscribeHistory(data) {
  return request({
    // url: "api/subscribeHistory",
    url:"notifyOTTPAYForRedirect",
    method: "post",
    data
  })
}
//查询账单
export function check(params) {
  return request({
    url: "api/balancehistory",
    method: "GET",
    params
  })
}
//注册
export function sign(data) {
  return request({
    url: "api/registerUser",
    method: "post",
    data,
    timeout:10000
  })
}
//创建运单
export function createOrder(data) {
  return request({
    url: "api/order/createOrder",
    method: "post",
    data
  })
}
//用户
export function user(params) {
  return request({
    url: "api/user",
    method: "GET",
    params,
    timeout:10000
  })
}
export function getUser(params){
  return request({
    url: "api/user/getUser",
    method: "GET",
    params
  })
}

//确认发货地址api/order/confirmAddress
export function confirmAddress(data) {
  return request({
    url: "api/order/confirmAddress",
    method: "post",
    data
  })
}
//国内省市区api/baseArea/queryAllArea
export function queryAllArea(params) {
  return request({
    url: "api/baseArea/queryAllArea",
    method: "GET",
    params
  })
}
//确认订单api/order/confirmOrder
export function confirmOrder(params) {
  return request({
    url: "api/order/confirmOrder",
    method: "get",
    params
  })
}
//确认批次api/order/confirmOrder
export function confirmBatch(params) {
  return request({
    url: "api/order/confirmBatch",
    method: "get",
    params,
  })
}
//申请退运api/order/applyReturn
export function applyReturn(data) {
  return request({
    url: "api/order/applyReturn",
    method: "post",
    data
  })
}
//修改订单信息api/order/updateOrder
export function updateOrder(data) {
  return request({
    url: "api/order/updateOrder",
    method: "put",
    data
  })
}
export function selectOrderWareAll(params) {
  return request({
    url: "api/order/selectOrderWareAll",
    method: "GET",
    params
  })
}
//批次物流api/batch/getBatchsAndExpress
export function getBatchsAndExpress(params) {
  return request({
    url: "api/batch/getBatchsAndExpress",
    method: "GET",
    params
  })
}

export function getAllOrderStatusData(params) {
  return request({
    url: "api/orderstatus/getAllOrderStatus",
    method: "GET",
    params
  })
}
//批确认送货
export function confirmDelivery(data) {
  return request({
    url: "api/order/confirmDelivery",
    method: "post",
    data
  })
}
//快递100
export function queryExpress(params) {
  return request({
    url: "api/expressQuery/queryExpress",
    method: "get",
    params
  })
}
//包裹状态
export function orderstatus(params) {
  return request({
    url: "api/orderstatus",
    method: "get",
    params
  })
}

export function getAllOrderStatus(params) {
  return request({
    url: "api/orderstatus/getAllOrderStatus",
    method: "get",
    params,
  })
}
//首页订单数据
export function orderNumber(params) {
  return request({
    url: "api/order/selectHomePage",
    method: "get",
    params
  })
}
//退运数据数量
export function selectReturnOrderData(params) {
  return request({
    url: "api/order/selectReturnOrderData",
    method: "get",
    params
  })
}
//预约上门说明

export function systemSettings(params) {
  return request({
    url: "api/systemSettings",
    method: "get",
    params
  })
}
//首页图片
export function systemPhoto(params) {
  return request({
    url: "api/systemPhoto",
    method: "get",
    params
  })
}
//根据快递单号查询物流公司
export function queryExpressCompanyNumber(params) {
  return request({
    url: "api/expressQuery/queryExpressCompanyNumber",
    method: "get",
    params
  })
}
//高级账户月 日账单

export function recordBalanceHistory(params) {
  return request({
    url: "api/recordBalanceHistory",
    method: "get",
    params
  })
}
//核销账单
export function recordBalanceHistoryEdit(data) {
  return request({
    url: "api/recordBalanceHistory",
    method: 'put',
    data,
  })
}
//自提点查询

export function pickUpLocation(params) {
  return request({
    url: "api/pickUpLocation",
    method: 'get',
    params,
    timeout:10000,
  })
}
//修改用户信息

export function updateUser(data) {
  return request({
    url: "api/user/updateUser",
    method: 'put',
    data,
  })
}
///录单计算送货费用
export function calculateDeliveryCost(data) {
  return request({
    url: "api/order/calculateDeliveryCost",
    method: 'post',
    data,
  })
}
//高级账户提货付款

export function payOrder(data) {
  return request({
    url: "api/pay/payOrder",
    method: 'post',
    data,
  })
}
//高级用户送货
export function deliveryOrder(data) {
  return request({
    url: "api/order/deliveryOrder",
    method: 'post',
    data,
  })
}
//用户线路限制
export function bannedUserRoute(params) {
  return request({
    url: "api/bannedUserRoute",
    method: 'get',
    params,
  })
}
//根据用户代码查用户信息/
export function getUserInfo(params) {
  return request({
    url: "api/user/getUserInfo",
    method: 'get',
    params,
  })
}
//根据快递单号查运单精准查询
export function selectOrderAllAccuracy(params) {
  return request({
    url: "api/order/selectOrderAllAccuracy",
    method: 'get',
    params,
  })
}
//支付方式
export function payMethod(params) {
  return request({
    url: "api/payMethod",
    method: 'get',
    params,
  })
}
//充值
export function toPayForRecharge(data) {
  return request({
    url: "api/pay/toPayForRecharge",
    method: 'post',
    data,
  })
}
//查询交易记录

export function accountTransactionRecord(params) {
  return request({
    url: "api/accountTransactionRecord/getAccountTransactionRecordsUnlimited",
    method: 'get',
    params,
  })
}
//银联支付
export function toUnionPayPayForRecharge(data) {
  return request({
    url: "api/pay/toUnionPayPayForRecharge",
    method: 'post',
    data,
  })
}
//删除未入库的包裹
export function deleteNotWarehousedOrder(params) {
  return request({
    url: "api/order/deleteNotWarehousedOrder",
    method: 'post',
    params,
  })
}
//查询全部包裹
export function getAllOrders(params) {
  return request({
    url: "api/order/getAllOrders",
    method: 'get',
    params,
  })
}
export default {
  getAllOrders,
  deleteNotWarehousedOrder,
  toUnionPayPayForRecharge,
  getAllOrderStatusData,
  getAllOrderStatus,
  accountTransactionRecord,
  toPayForRecharge,
  payMethod,
  getUser,
  selectOrderAllAccuracy,
  getUserInfo,
  bannedUserRoute,
  deliveryOrder,
  payOrder,
  calculateDeliveryCost,
  updateUser,
  pickUpLocation,
  getWarehousesNumber,
  gerRouteNumber,
  recordBalanceHistoryEdit,
  recordBalanceHistory,
  queryExpressCompanyNumber,
  systemPhoto,
  systemSettings,
  confirmBatch,
  selectReturnOrderData,
  orderNumber,
  delAddress,
  orderstatus,
  queryExpress,
  confirmDelivery,
  getBatchsAndExpress,
  selectOrderWareAll,
  editAddress,
  updateOrder,
  applyReturn,
  confirmOrder,
  queryAllArea,
  confirmAddress,
  addAddress,
  createOrder,
  user,
  sign,
  check,
  subscribeHistory,
  address,
  fileUp,
  goods,
  getInfo,
  logout,
    login,
    warehouse,
    circuit,
    express,
    batch,
    orderList,
    kind,
    orderDetail,
    boxList
  }


// WEBPACK FOOTER //
// ./src/api/userMG.js